import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "indented", "children"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Heading from 'components/Heading';
import { TeamPill } from 'components/Pill';
import Stack from 'components/Stack';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import TooltipButton from 'components/TooltipButton';
function TeamGroupPanel(_ref) {
  var id = _ref.id,
    indented = _ref.indented,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    id: id,
    role: "group"
  }, otherProps, {
    textColor: "text",
    background: "shaded",
    borderRadius: "small",
    px: "s",
    py: "xs",
    ml: indented ? 'xxl' : undefined
  }), children);
}
function TeamList(_ref2) {
  var emptyText = _ref2.emptyText,
    teams = _ref2.teams,
    groupId = _ref2.groupId,
    onRequestSelectTeams = _ref2.onRequestSelectTeams,
    onRemoveTeam = _ref2.onRemoveTeam,
    disabled = _ref2.disabled,
    dimmedWhenEmpty = _ref2.dimmedWhenEmpty;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var button = /*#__PURE__*/React.createElement(TooltipButton, {
    size: "small",
    variant: "transparent",
    icon: "edit",
    isDisabled: disabled,
    onClick: function onClick() {
      return onRequestSelectTeams(groupId);
    },
    mt: -1,
    title: disabled ? t('widget_team_disabled') : undefined,
    tooltipPlacement: "right"
  }, t('actions_select_teams'));
  if (!(teams !== null && teams !== void 0 && teams.length)) {
    return /*#__PURE__*/React.createElement(Heading, {
      as: "p",
      size: "small",
      dimmed: disabled || dimmedWhenEmpty
    }, emptyText, " ", button);
  }
  return /*#__PURE__*/React.createElement(InlineList, {
    as: "div",
    itemAs: "span",
    spacing: "xs"
  }, teams.map(function (team) {
    var id = team.id,
      name = team.name;
    return /*#__PURE__*/React.createElement(TeamPill, {
      key: id,
      team: team,
      onDelete: function onDelete() {
        return onRemoveTeam(id, groupId);
      },
      deleteLabel: t('actions_remove_team', {
        name: name
      })
    });
  }), button);
}
function AdvancedAudienceWidget(_ref3) {
  var baseAudienceType = _ref3.baseAudienceType,
    includedTeamGroups = _ref3.includedTeamGroups,
    excludedTeams = _ref3.excludedTeams,
    onRequestSelectTeams = _ref3.onRequestSelectTeams,
    onRemoveTeam = _ref3.onRemoveTeam,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    isAdvancedMode = _ref3.isAdvancedMode;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var BASE_EMPTY_TEXT = {
    teams: t('state_everyone_with_access'),
    all: t('state_everyone')
  };
  var _includedTeamGroups = _toArray(includedTeamGroups),
    firstTeamGroup = _includedTeamGroups[0],
    otherTeamGroups = _includedTeamGroups.slice(1);
  // add an extra group to the end if there are less than 4 already
  var maxTeamGroups = 5;
  var maxOtherTeamGroups = maxTeamGroups - 1;
  var indentedTeamGroups = otherTeamGroups && otherTeamGroups.length >= maxOtherTeamGroups ? otherTeamGroups : [].concat(_toConsumableArray(otherTeamGroups), [[]]);
  function getSelectTeamsHandler(teamGroupIndex) {
    return function () {
      return onRequestSelectTeams(teamGroupIndex);
    };
  }
  function getRemoveTeamHandler(teamGroupIndex) {
    return function (teamId) {
      return onRemoveTeam(teamId, teamGroupIndex);
    };
  }
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(TeamGroupPanel, {
    id: "share-group-0",
    "aria-label": t('widget_include_group', {
      id: 1
    })
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s",
    id: "share-group-description"
  }, t('widget_include_message_colon')), /*#__PURE__*/React.createElement(TeamList, {
    disabled: disabled,
    emptyText: BASE_EMPTY_TEXT[baseAudienceType] || BASE_EMPTY_TEXT.teams,
    groupId: 0,
    teams: firstTeamGroup,
    onRequestSelectTeams: getSelectTeamsHandler(0),
    onRemoveTeam: getRemoveTeamHandler(0)
  })), isAdvancedMode && (indentedTeamGroups === null || indentedTeamGroups === void 0 ? void 0 : indentedTeamGroups.map(function (teamGroup, i) {
    // Disable this panel if the previous team group is empty
    var isDisabled = (includedTeamGroups === null || includedTeamGroups === void 0 ? void 0 : includedTeamGroups.flat().length) === 0;
    var groupId = i + 1;
    return /*#__PURE__*/React.createElement(TeamGroupPanel, {
      indented: true,
      key: i,
      id: "share-group-".concat(groupId),
      "aria-label": t('widget_include_group', {
        id: groupId + 1
      })
    }, /*#__PURE__*/React.createElement(Text, {
      size: "s",
      dimmed: isDisabled
    }, t('widget_teams_message_colon')), /*#__PURE__*/React.createElement(TeamList, {
      dimmedWhenEmpty: true,
      disabled: isDisabled,
      emptyText: t('widget_none_selected'),
      groupId: groupId,
      teams: teamGroup,
      onRequestSelectTeams: getSelectTeamsHandler(groupId),
      onRemoveTeam: getRemoveTeamHandler(groupId)
    }));
  })), isAdvancedMode && /*#__PURE__*/React.createElement(TeamGroupPanel, {
    id: "exclude-group",
    "aria-label": t('widget_exclude_group', {
      id: 1
    })
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s"
  }, t('widget_exclude_message_colon')), /*#__PURE__*/React.createElement(TeamList, {
    disabled: disabled,
    dimmedWhenEmpty: true,
    emptyText: t('widget_none_selected'),
    groupId: -1,
    teams: excludedTeams,
    onRequestSelectTeams: getSelectTeamsHandler(-1),
    onRemoveTeam: getRemoveTeamHandler(-1)
  })));
}
export default AdvancedAudienceWidget;